import { useVariant } from '@/unleash';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';

export const useGetFundLandingData = () => {
  const fundCode = useGetFundCodeFromQuery();

  const { data } = useVariant('web.invest.fundLanding');

  const fundLandingData = data && data[fundCode];

  return {
    fundLandingData,
  };
};
